import { memo, useMemo } from "react";

import { CollectionImageCard } from "@components/CollectionContentCard/CollectionImageCard.view";
import { CollectionImageTextCard } from "@components/CollectionContentCard/CollectionImageTextCard.view";
import { CollectionTextCard } from "@components/CollectionContentCard/CollectionTextCard.view";
import { CollectionVideoCard } from "@components/CollectionContentCard/CollectionVideoCard.data";
import { getCollectionContentCardType } from "@react/utilities/collection";
import {
  CollectionContentCardType,
  type CollectionContentCard as CollectionContentCardPropType,
} from "@root/tablescape/state";
import { tw } from "classnames";

const styles = {
  base: tw("col-span-2", "flex", "flex-col", "md:col-span-1", "md:h-full"),
};

const CollectionContentCardBase = (
  collectionContentCard: CollectionContentCardPropType
) => {
  const {
    background,
    ctaText,
    ctaUrl,
    description,
    image,
    mobileImage,
    title,
    videoControlColor,
    videoMp4,
    videoWebm,
  } = collectionContentCard;

  const contentCardByType = useMemo(() => {
    switch (getCollectionContentCardType(collectionContentCard)) {
      case CollectionContentCardType.IMAGE_CARD:
        return (
          <CollectionImageCard
            ctaUrl={ctaUrl}
            image={image}
            mobileImage={mobileImage}
          />
        );
      case CollectionContentCardType.IMAGE_TEXT_CARD:
        return (
          <CollectionImageTextCard
            background={background}
            ctaUrl={ctaUrl}
            description={description}
            image={image}
            mobileImage={mobileImage}
            title={title}
          />
        );
      case CollectionContentCardType.VIDEO_CARD:
        return (
          <CollectionVideoCard
            videoControlColor={videoControlColor}
            videoMp4={videoMp4}
            videoWebm={videoWebm}
          />
        );
      default:
        return (
          <CollectionTextCard
            background={background}
            ctaText={ctaText}
            ctaUrl={ctaUrl}
            description={description}
            title={title}
          />
        );
    }
  }, [
    background,
    collectionContentCard,
    ctaText,
    ctaUrl,
    description,
    image,
    mobileImage,
    title,
    videoControlColor,
    videoMp4,
    videoWebm,
  ]);

  return <li className={styles.base}>{contentCardByType}</li>;
};

export const CollectionContentCard = memo(CollectionContentCardBase);
